import { Button, Modal, SecondaryButton } from 'components';
import { StyledAdminConfirmModal } from './styles';
import { ReactComponent as CloseIcon } from 'assets/icons/close-modal-icon.svg';
import { useTranslation } from 'react-i18next';

interface IAdminConfirmModalProps {
  children?: React.ReactNode;
  title: string;
  onConfirm: () => void;
  onCancel: () => void;
  show: boolean;
}

export const AdminConfirmModal = ({
  children,
  title,
  onConfirm,
  onCancel,
  show,
}: IAdminConfirmModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal show={show}>
      <StyledAdminConfirmModal>
        <div className="confirm-modal-topline">
          <h3 className="confirm-modal-title">{t('adminPage.confirmModal.heading')}</h3>
          <button className="confirm-modal-button" onClick={onCancel}>
            <CloseIcon />
          </button>
        </div>
        <div className="confirm-modal-body">
          <p className="confirm-modal-text">{title}</p>
        </div>
        <div className="confirm-modal-buttons">
          <Button title={t('adminPage.confirmModal.apply')} onClick={onConfirm} />
          <SecondaryButton title={t('adminPage.confirmModal.cancel')} outline onClick={onCancel} />
        </div>
      </StyledAdminConfirmModal>
    </Modal>
  );
};
